import { SET_CONTAINER_REPAIR } from "constants-lib/actionTypes"

export const setContainerRepair = (bulkRepair) => (dispatch) => {
  dispatch({
    type: SET_CONTAINER_REPAIR,
    payload: bulkRepair,
  })
}
